import Portal from "@stadium/ui/src/components/portal";
import useRouter from "@stadium/hooks/lib/use-custom-route";
import React, { useEffect, useRef, useState } from "react";

const UnsavedChangesAlert = ({ Component, componentProps, type, classes, shouldConfirmLeave }) => {
  const [shouldShowLeaveConfirmDialog, setShouldShowLeaveConfirmDialog] = useState(false);
  const [nextRouterPath, setNextRouterPath] = useState();

  const Router = useRouter();
  const canProceed = useRef(false);

  useEffect(() => {
    const callback = (path) => {
      if (!canProceed.current && path.split("?")[0] !== Router.pathname) {
        setNextRouterPath(path);
        setShouldShowLeaveConfirmDialog(true);
        return false;
      }
      return true;
    };
    shouldConfirmLeave && Router.events.on("beforePush", callback);
    shouldConfirmLeave && Router.events.on("beforeRefresh", callback);
    return () => {
      shouldConfirmLeave && Router.events.off("beforePush", callback);
      shouldConfirmLeave && Router.events.off("beforeRefresh", callback);
    };
  }, [shouldConfirmLeave]);

  const onproceed = () => {
    canProceed.current = true;
    Router.push(nextRouterPath);
  };

  const onRejectRouteChange = () => {
    setNextRouterPath(null);
    setShouldShowLeaveConfirmDialog(false);
  };

  return (
    shouldShowLeaveConfirmDialog && (
      <Portal id="modal-root" dataContainerId={type}>
        <Component {...componentProps} onConfirm={onproceed} onReject={onRejectRouteChange} />
      </Portal>
    )
  );
};

export default UnsavedChangesAlert;
